<template>
	<div class="table-overflow-hide">
		<div class="directoryTable scrollable-55vh">
			<table class="table">
				<thead class="sticky-header">
					<tr>
						<th class="icon-col"></th>
						<SortHeader
							title="name"
							:asc="currentSort.asc"
							:sort-key="currentSort.key"
							@click="() => setSort('name')"
							data-cy="report-table-header"
							class="header-cell"
							color="#695b59"
							weight="500"
						></SortHeader>
						<th class="icon-col"></th>
						<th>room</th>
						<th class="icon-col">
							<SortHeader
								title="description"
								:asc="currentSort.asc"
								:sort-key="currentSort.key"
								@click="() => setSort('description')"
								data-cy="report-table-header-description"
								class="header-cell"
								color="#695b59"
								weight="500"
							></SortHeader>
						</th>
						<th>
							<span class="d-flex align-center justify-content-center">
								Modify Schedule
								<v-checkbox
									:model-value="
										filteredData.length && filteredData.every((i) => i.modify_schedule)
									"
									@update:model-value="
										filteredData.map((i) => {
											i.modify_schedule = $event;
											if ($event) i.set_breaks = false;
										})
									"
									style="
										max-width: max-content;
										max-height: 24px;
										overflow: hidden;
										display: flex;
										align-items: center;
									"
									class="custom-input"
									density="compact"
									:disabled="deleted || !canEditDirectory"
								></v-checkbox>
							</span>
							<!-- </typography> -->
						</th>
						<th>
							<span class="d-flex align-center justify-content-center">
								Set Breaks
								<v-checkbox
									:model-value="
										filteredData.length && filteredData.every((i) => i.set_breaks)
									"
									@update:model-value="
										filteredData.map((i) => {
											i.set_breaks = $event;
											if ($event) i.modify_schedule = false;
										})
									"
									style="
										max-width: max-content;
										max-height: 24px;
										overflow: hidden;
										display: flex;
										align-items: center;
									"
									class="custom-input"
									density="compact"
									:disabled="deleted || !canEditDirectory"
								></v-checkbox>
							</span>
						</th>
						<th class="icon-col">
							<v-btn
								@click="teachersS.teachers.reload()"
								icon
								size="x-small"
								color="gray200"
								:loading="teachersS.teachers.loading"
								style="max-width: 20px; max-height: 20px"
							>
								<v-icon>mdi-reload</v-icon></v-btn
							>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="row in paginatedResults"
						:key="row.uid"
						:class="{
							'table-row': true,
							selected:
								(editModal.show && editModal.teacher === row) ||
								(editRelationModal.show && editRelationModal.teacher === row),
						}"
					>
						<td>
							<v-btn
								@click="updatePinUser(row)"
								:loading="state.loadPinned.includes(row.uid)"
								color="gray300"
								density="compact"
								icon
								variant="text"
								class="custom-input"
								:disabled="deleted || !canEditDirectory"
							>
								<v-tooltip location="bottom" class="custom-tooltip" activator="parent">
									Lock Record
								</v-tooltip>
								<v-icon :color="row.pinned ? 'primary' : 'gray500'"
									>mdi-lock-outline</v-icon
								>
							</v-btn>
						</td>
						<td data-cy="table-col-name">
							<div class="d-flex align-center justify-start">
								<div>{{ row.teacher_fname }} {{ row.teacher_lname }}</div>
								<div>
									<v-btn
										@click="
											editModal.show = true;
											editModal.teacher = row;
										"
										color="gray300"
										density="compact"
										icon
										variant="text"
										:disabled="!canEditDirectory"
										data-cy="directory-teacher-edit-btn"
									>
										<v-icon color="gray500">mdi-note-edit</v-icon>
									</v-btn>
								</div>
							</div>
						</td>
						<td>
							<v-btn
								color="gray300"
								density="compact"
								icon
								variant="text"
								@click="impersonate(row.uid, row.school_id)"
								:loading="state.loadImpersonate.includes(row.uid)"
								:disabled="deleted || !canEditDirectory"
								data-cy="directory-teacher-impersonate-btn"
							>
								<v-tooltip activator="parent" location="bottom"
									>Log in as this teacher</v-tooltip
								>
								<v-icon color="gray500">mdi-security</v-icon>
							</v-btn>
						</td>
						<td>
							{{ row.room_assignment }}
						</td>
						<td data-cy="table-col-title">
							{{ row.teacher_classes }}
						</td>
						<td>
							<span class="d-flex align-center justify-content-center">
								<v-progress-circular
									v-if="state.loadMSchedule.includes(row.uid)"
									indeterminate
									size="small"
									color="primary"
								></v-progress-circular>

								<v-checkbox
									v-else
									class="custom-input"
									style="
										max-width: max-content;
										max-height: 24px;
										overflow: hidden;
										display: flex;
										align-items: center;
									"
									density="compact"
									:model-value="row.modify_schedule"
									@update:model-value="(val:boolean)=>
                  updateTeacherModifySet(row,val, 'modify')
                  "
									:disabled="deleted || !canEditDirectory"
								></v-checkbox>
							</span>
						</td>
						<td>
							<span class="d-flex align-center justify-content-center">
								<v-progress-circular
									v-if="state.loadSBreaks.includes(row.uid)"
									indeterminate
									size="small"
									color="primary"
								></v-progress-circular>
								<v-checkbox
									v-else
									class="custom-input"
									style="
										max-width: max-content;
										max-height: 24px;
										overflow: hidden;
										display: flex;
										align-items: center;
									"
									density="compact"
									:model-value="row.set_breaks"
									@update:model-value="(val:boolean)=>
                  updateTeacherModifySet(row,val, 'breaks')
                  "
									:disabled="deleted || !canEditDirectory"
								></v-checkbox>
							</span>
						</td>
						<td tabindex="1">
							<v-tooltip
								v-if="schoolStore.schoolDetails.data?.integration == 'none'"
								activator="parent"
								location="bottom"
								>teachers don't have relations when integration is set to none</v-tooltip
							>
							<v-btn
								@click="
									editRelationModal.show = true;
									editRelationModal.teacher = row;
								"
								color="gray300"
								density="compact"
								icon
								variant="text"
								class="custom-input"
								:disabled="
									deleted ||
									!canEditDirectory ||
									schoolStore.schoolDetails.data?.integration == 'none'
								"
							>
								<v-icon color="gray500">mdi-account-group</v-icon>
							</v-btn>
						</td>
					</tr>
				</tbody>
			</table>
			<div
				v-if="teachersS.teachers.loading && !teachersS.teachers.data.length"
				style="
					height: calc(100% - 60px);
					background-color: rgba(246, 247, 237, 0.5);
					border-radius: 15px;
				"
			>
				<loading-state text="Loading Teachers"></loading-state>
			</div>
			<div
				v-if="!teachersS.teachers.loading && !teachersS.teachers.data.length"
				style="
					height: calc(100% - 60px);
					background-color: rgba(246, 247, 237, 0.5);
					border-radius: 15px;
				"
			>
				<div class="empty-state">
					<figure style="max-width: 300px">
						<IconListEmptyState />
					</figure>
					<div class="title">We couldn't find any Teachers.</div>
					<p>Try reloading the page or adding a new teacher.</p>
				</div>
			</div>
		</div>
	</div>
	<div class="table-pagination-btns">
		<pagination v-bind="forComponent()"></pagination>
		<div class="table-buttons" v-if="canEditDirectory">
			<v-btn @click="addModal.show = true" data-cy="directory-teacher-create-btn"
				>Create New</v-btn
			>
			<v-btn
				@click="uploadModal.show = true"
				color="#E5E4DB"
				append-icon="mdi-tray-arrow-up"
				>Upload</v-btn
			>
			<div class="d-flex align-center">
				<v-btn
					@click="download"
					:loading="state.loadDownload"
					color="#E5E4DB"
					append-icon="mdi-tray-arrow-down"
					>Download</v-btn
				>
				<div class="ml-1" tabindex="1">
					<v-tooltip location="bottom" activator="parent">Download Relations</v-tooltip>
					<RelationsDownload :download-types="['enrollment']"></RelationsDownload>
				</div>
			</div>
			<v-btn v-if="!deleted" :loading="state.loadingSave" @click="saveAction">Save</v-btn>
		</div>
	</div>
	<edit-teacher-modal
		v-model:show="editModal.show"
		:teacher="editModal.teacher"
	></edit-teacher-modal>
	<teacher-relations-modal
		v-model:show="editRelationModal.show"
		:directory-entity="editRelationModal.teacher"
		:entity-type="'teacher'"
		:entity-id="editRelationModal.teacher.uid"
		:entity-name="`${editRelationModal.teacher.teacher_fname} ${editRelationModal.teacher.teacher_lname}`"
		:tabs="['student', 'parent', 'team', 'class']"
		@entity-click="handleEntityClick"
	></teacher-relations-modal>
	<add-teacher-modal
		v-model:show="addModal.show"
		@update:search="
			$emit('update:search', $event);
			addModal.show = false;
		"
	></add-teacher-modal>
	<upload-csv-modal v-model:show="uploadModal.show" :tab="props.tab"></upload-csv-modal>
</template>

<script setup lang="ts">
import type { TeachersType } from "@/api_types/school";
import { reactive, watch } from "vue";
import usePaginate from "@/hooks/usePaginate";
import { computed } from "vue";
import pagination from "@/components/pagination.vue";
import downloadFile, { complexSearch } from "@/utils";
import EditTeacherModal from "./editTeacherModal.vue";
import AddTeacherModal from "./addTeacherModal.vue";
import useDirectoryNavigation from "@/stores/school/directoryNavigation";
import TeacherRelationsModal from "@/components/school/directory/RelationshipModal.vue";
import useTeachers from "@/stores/school/teachers";
import { useAlertsStore } from "@/stores/alerts";
import authService from "@/services/auth.service";
import FetchService from "@/services/fetch.service";
import { useAuthenticationStore } from "@/stores/authentication";
import LoadingState from "@/components/loadingState.vue";
import IconListEmptyState from "@/assets/icons/list-empty-state.svg";
// @ts-ignore
import uploadCsvModal from "@/components/school/directory/uploadCsvModal.vue";
import RelationsDownload from "../relationsDownload.vue";
import { useSchoolStore } from "@/stores/school";
import useTableSort from "@/hooks/useTableSort";
import { sort } from "@/utils/sort";
import SortHeader from "@/components/global/sortHeader.vue";

const props = defineProps<{
	tab: "teacher" | "parent" | "student" | "team";
	search: string;
	deleted: boolean;
	selectedEntity?: any;
}>();
const emit = defineEmits<{
	(e: "update:search", ...args: any[]): void;
}>();

const { currentSort, setSort } = useTableSort([
	{
		key: "name",
		title: "name",
		sortKey: "name",
	},
]);

const teachersS = useTeachers();
const authStore = useAuthenticationStore();
const canEditDirectory = computed(() => authStore.hasPolicy("school.directory.teacher.write"));
const directoryNav = useDirectoryNavigation();
const schoolStore = useSchoolStore();

teachersS.teachers.reload();

const state = reactive({
	search: "",
	loadImpersonate: [] as string[],
	loadPinned: [] as string[],
	loadMSchedule: [] as string[],
	loadSBreaks: [] as string[],
	loadDownload: false,
	loadingSave: false,
});

const editModal = reactive({
	show: false,
	teacher: ({} as any) as TeachersType[number],
});

const addModal = reactive({
	show: false,
});

const uploadModal = reactive({
	show: false,
});

const editRelationModal = reactive({
	show: false,
	teacher: ({} as any) as TeachersType[number],
});

const filteredData = computed(() => {
	return sort(
		teachersS.teachers.data?.filter((i) => {
			if (i.deleted !== props.deleted) return false;
			return complexSearch(
				props.search || "",
				`${i.teacher_fname} ${i.teacher_lname} ${i.email}`
			);
		}) || [],
		(i) => `${i.teacher_lname} ${i.teacher_fname}`,
		currentSort.value.asc
	);
});

const { forComponent, paginatedResults } = usePaginate(filteredData);

const impersonate = async (teacher_uid, school_id) => {
	state.loadImpersonate.push(teacher_uid);
	try {
		const res = await FetchService.fetchData(
			`/impersonate?uid=${teacher_uid}&school_id=${school_id}&type=teacher`,
			"get"
		);
		if (!res) throw "Failed";
		const data = authService.parseJwt(res, false);
		localStorage.setItem(authStore.getTokenName("teacher"), JSON.stringify(data));
		window.open(`/${authStore.account}/teacher`, "_blank");
	} catch (error) {
		useAlertsStore().addAlert(
			"error",
			"Failed to impersonate teacher, please try again later"
		);
	}
	state.loadImpersonate = state.loadImpersonate.filter((str) => str !== teacher_uid);
};

const updatePinUser = async (teacher: TeachersType[number]) => {
	state.loadPinned.push(teacher.uid);
	const res = await teachersS.updateTeacher(teacher.uid, {
		pinned: !teacher.pinned,
		teacher_fname: teacher.teacher_fname,
		teacher_lname: teacher.teacher_lname,
		email: teacher.email,
	});
	useAlertsStore().addAlert(
		res.teacher ? "success" : "error",
		res.teacher ? "Teacher saved successfully" : "Failed to save teacher",
		5
	);
	state.loadPinned = state.loadPinned.filter((str) => str !== teacher.uid);
};
const updateTeacherModifySet = async (
	teacher: TeachersType[number],
	val: boolean,
	type: "modify" | "breaks"
) => {
	state[type === "breaks" ? "loadSBreaks" : "loadMSchedule"].push(teacher.uid);
	const res = await teachersS.updateTeacher(teacher.uid, {
		teacher_fname: teacher.teacher_fname,
		teacher_lname: teacher.teacher_lname,
		email: teacher.email,
		modify_schedule: type == "modify" ? val : val ? false : teacher.modify_schedule,
		set_breaks: type == "breaks" ? val : val ? false : teacher.set_breaks,
	});
	useAlertsStore().addAlert(
		res.teacher ? "success" : "error",
		res.teacher ? "Teacher saved successfully" : "Failed to save teacher",
		5
	);
	state[type === "breaks" ? "loadSBreaks" : "loadMSchedule"] = state[
		type === "breaks" ? "loadSBreaks" : "loadMSchedule"
	].filter((str) => str !== teacher.uid);
};

const saveAction = async () => {
	state.loadingSave = true;
	const res = await FetchService.fetchData("/teachers/bulk-update", "put", {
		modify_schedule: teachersS.teachers.data
			.filter((t) => t.modify_schedule && !t.deleted)
			.map((t) => t.uid),
		set_breaks: teachersS.teachers.data
			.filter((t) => t.set_breaks && !t.deleted)
			.map((t) => t.uid),
	});

	if (res?.status == true) {
		useAlertsStore().addAlert("success", "Teachers Settings Saved");
	} else
		useAlertsStore().addAlert("error", "Failed to save teacher settings");

	state.loadingSave = false;
};

const download = async () => {
	state.loadDownload = true;
	const res = await FetchService.fetchData("/teachers/download", "get", undefined, true);
	const cType = res?.res?.headers.get?.("content-type") || "";

	if (typeof res?.data === "string" && cType.includes("text/csv")) {
		downloadFile(
			res.data,
			res?.res?.headers
				?.get("content-disposition")
				?.split("filename=")?.[1]
				?.replace(/"/g, "") || "teachers.csv",
			"text/csv"
		);
	} else {
		useAlertsStore().addAlert(
			"error",
			"Failed to download teachers, please try again later",
			10
		);
	}
	state.loadDownload = false;
};

// Handle entity clicks from relationship modal
const handleEntityClick = (entityData: any) => {
	// Navigate to the entity using the store
	directoryNav.navigateToEntity(entityData);
};

// Watch for selected entity changes and open the relationship modal
watch(() => directoryNav.selectedEntity, (newEntity) => {
	if (newEntity && newEntity.entityType === 'teacher') {
		// Find the teacher in the current data
		const teacher = teachersS.teachers.data.find(t => t.uid === newEntity.entityId);
		if (teacher) {
			editRelationModal.teacher = teacher;
			editRelationModal.show = true;
			// Clear the selected entity after opening the modal
			directoryNav.clearSelectedEntity();
		}
	}
}, { immediate: true });
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
// .scrollable {
//   max-height: 55vh;
//   height: 55vh;
//   overflow: scroll;
// }

.icon-col {
	width: 0px;
}
.table-row {
	td {
		transition: background-color 0.3s;
	}
	&.selected {
		td {
			background-color: #e6e6e689 !important;
		}
	}
}
</style>
